import { useEffect, useState } from "react";
import { Wrapper, ContentTypeRender } from "nystem-components";
import app from "nystem";

const ConditionalSubscriptionProductChange = ({ value, model, path }) => {
  const [show, setShow] = useState(false);
  const productId = [value.product].flat()[0];

  useEffect(() => {
    let active = true;

    app.database.product
      .get({ id: productId })
      .then(({ data: product }) => {
        return app.database.program
          .get({ id: [product.program].flat()[0] })
          .then(({ data: program }) => {
            const productOptions = program.productoptions || [];
            if (product.recurring === "month")
              return { oldProduct: product, productOptions };

            return Promise.all(
              (program.productoptions || []).map((id) =>
                app.database.product.get({ id })
              )
            ).then((products) => ({ oldProduct: product, products }));
          });
      })
      .then(({ oldProduct, productOptions, products }) => {
        if (!active) return;

        const canChange =
          oldProduct.recurring === "month"
            ? productOptions.some((id) => id !== productId)
            : products.some(
                ({ data: product }) =>
                  product._id !== productId && product.recurring === "year"
              );
        setShow(canChange);
      })
      .catch(() => {
        if (active) setShow(false);
      });

    return () => {
      active = false;
    };
  }, [productId]);

  if (!show) return null;

  return (
    <Wrapper className={model.className}>
      <ContentTypeRender path={path} items={model.item} />
    </Wrapper>
  );
};

export default ConditionalSubscriptionProductChange;
